import React, { useCallback } from "react";
import { EVENT_TYPE_COLORS, EVENT_TYPES } from "../../eventHistory.constants";
import styles from "./timeline.module.css";
import { StatusSuccess } from "../../../../../../../../Components/Icons/statusSuccess";
import { StatusPending } from "../../../../../../../../Components/Icons/statusPending";

interface TimelineProps {
    eventType: EVENT_TYPES;
}

export const Timeline = ({ eventType }: TimelineProps) => {
    const renderIcon = useCallback(() => {
        switch (eventType) {
            case EVENT_TYPES.SEQUENTIAL:
                return <StatusSuccess fillColor={EVENT_TYPE_COLORS[eventType].primary} />;
            case EVENT_TYPES.CUSTOM:
                return <StatusPending fillColor={EVENT_TYPE_COLORS[eventType].primary} />;
            default:
                return null;
        }
    }, [eventType]);
    return (
        <div className={styles.timelineNode}>
            <div className={styles.iconWrapper} style={{ background: EVENT_TYPE_COLORS[eventType].secondary }}>
                {renderIcon()}
            </div>
        </div>
    )
}
